import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: 'index',
    meta: {
      title: "index",
    },
    component: () => import("../views/index"),
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'home',
        meta: {
          title: "首页",
          noScroll: true,
        },
        component: () => import('../views/home'),
        children: []
      },
      {
        path: "/products",
        name: 'products',
        meta: {
          title: "产品中心",
          scrollTo: { x: 0, y: 0 }
        },
        component: () => import("../views/products"),
        children: []
      },
      {
        path: "/productDetail",
        name: 'productDetail',
        meta: {
          title: "产品详情",
          scrollTo: { x: 0, y: 0 }
        },
        component: () => import("../views/productDetail"),
        children: []
      },
      {
        path: "/news",
        name: 'news',
        meta: {
          title: "资讯动态",
          scrollTo: { x: 0, y: 0 }
        },
        component: () => import("../views/news"),
        children: []
      },
      {
        path: "/newDetail",
        name: 'newDetail',
        meta: {
          title: "资讯详情",
          scrollTo: { x: 0, y: 0 }
        },
        component: () => import("../views/newDetail"),
        children: []
      },
      {
        path: "/aboutUs",
        name: 'aboutUs',
        meta: {
          title: "关于我们",
          noScroll: true,
        },
        component: () => import("../views/aboutUs"),
        children: []
      },
      {
        path: "/contactUs",
        name: 'contactUs',
        meta: {
          title: "联系我们",
          noScroll: true,
        },
        component: () => import("../views/contactUs"),
        children: []
      },
    ]
  },
  {
    path: "/404",
    name: '404',
    meta: {
      title: "404",
    },
    component: () => import("../views/error/404"),
    children: []
  },

]


const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (to.meta.noScroll) {
      return false;
    }
    if (to.meta.scrollTo) {
      return to.meta.scrollTo;
    }
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {//beforeEach是router的钩子函数，在进入路由前执行
  if (to.meta.title) {//判断是否有标题
    document.title = "弓网科技" + "-" + to.meta.title;
  }
  let activePath = to.path;
  if (to.path === '/productDetail') activePath = '/products';
  else if (to.path === '/newDetail') activePath = '/news';

  store.commit('setActiveMenuIndex', activePath); // 全局同步
  next()  //执行进入路由，如果不写就不会进入目标页
})
export default router
